import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { IUnitControlWithStateModel } from '@apps-common/types/portal/unit-control'

const getMyMonitoringControlWithState = async (controlId: number): Promise<IUnitControlWithStateModel> =>
  axios.get(`/my-monitoring/control/GetControlWithState?controlId=${controlId}`).then((res) => res.data?.data)

type Props = {
  controlId: number
}

export const useMyMonitoringGetControlWithState = (notify?: boolean, onSuccess?: (data: IUnitControlWithStateModel) => void) =>
  useMutation({
    mutationKey: ['getMyMonitoringControlWithState'],
    mutationFn: ({ controlId }: Props) => getMyMonitoringControlWithState(controlId),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Fetched control.')
      }
    },
    onError: (error) => {
      if (notify) {
        toastError(error?.message || 'Failed to fetch control.')
      }
    },
    throwOnError: false
  })
